import React, { ReactElement } from 'react';
import { useMediaQuery } from 'react-responsive';
import { BreakpointMedia } from '../../utils/config';
import styles from './LimitedTimeOffering.module.scss';
import { LtoItem } from '../../models/product.types';

type Props = {
  setCurrentLTORecipe?: ((index: any) => void) | null;
  currentLTORecipe: number;
  ltoItem?: LtoItem;
}

function CurrentRecipeSelector({
  currentLTORecipe,
  setCurrentLTORecipe,
  ltoItem,
}: Props): ReactElement {
  const resizeImages = !useMediaQuery({ query: BreakpointMedia.MIN_MD });
  return (
    <div className={styles.recipe_selector}>
      <hr />
      <div className={styles.slider_container}>
        {ltoItem?.components
          .map((item, index) => (
            <div
              className={styles.slide}
              key={`${item.itemNumber}`}
              style={{ marginRight: `${resizeImages ? '.5rem' : '1.2rem'}` }}
            >
              <div className={styles.slide_content}>
                <div
                  aria-label="Select recipe"
                  tabIndex={0}
                  role="button"
                  className={`${styles.img} ${styles[`robin-${index}`]}`}
                  onClick={() => {
                    if (setCurrentLTORecipe) {
                      setCurrentLTORecipe(index);
                    }
                  }}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                      if (setCurrentLTORecipe) {
                        setCurrentLTORecipe(index);
                      }
                    }
                  }}
                  style={{
                    width: `${resizeImages ? '90px' : '120px'}`,
                    height: `${resizeImages ? '90px' : '120px'}`,
                    border: `${resizeImages ? '2px' : '3px'} solid ${index === currentLTORecipe ? 'black' : 'transparent'}`,
                  }}
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}

export default CurrentRecipeSelector;
